export const moengage = {
  trackOtpSent: async (data) => {
    try {
      if (window.Moengage) {
  
        debugger
        window.Moengage.identifyUser(data.phone).then(() => {
          data.fullName && window.Moengage.add_user_name(data.fullName);
          window.Moengage.add_mobile("91" + data.phone);
          data.email && window.Moengage.add_email(data.email);
          window.Moengage.add_user_attribute("utm_source", "LP_PAID_IIR");
          window.Moengage.add_user_attribute("PRODUCT_TAG_ID", "IIR");
          // console.log("MoEngage: OTP Sent Tracked");
  
          window.Moengage.track_event("OTP Sent", {
            "utm_source": "LP_PAID_IIR",
            "PRODUCT_TAG_ID": "IIR",
            "Full Name": data.fullName,
            "Email (standard)": data.email, 
            "Phone_Number": data.phone
          });
  
        });
      }
    } catch (error) {
      console.log("Error in MoEngage trackOtpSent:", error);
    }
  },
  trackOtpVerified: async (data) => {
    try {
      if (window.Moengage) {
        window.Moengage.identifyUser(data.phone).then(() => {
          window.Moengage.add_user_name(data.fullName);
          window.Moengage.add_email(data.email);
          window.Moengage.track_event("OTP Verified", {
            "utm_source": "LP_PAID_IIR",
            "PRODUCT_TAG_ID": "IIR",
            "Full Name": data.fullName,
            "Email (standard)": data.email, 
            "Phone_Number": data.phone
          });
          console.log("MoEngage: OTP Verified Tracked");
        });
      }
    } catch (error) {
      console.log("Error in MoEngage trackOtpVerified:", error);
    }
  },

  trackOtpDropped: async (data) => {
    try {
      if (window.Moengage) {
        // Re-identify to attach the drop event to the right profile
        window.Moengage.identifyUser(data.phone).then(() => {
          window.Moengage.track_event("OTP Dropped", { 
            "utm_source": "LP_PAID_IIR",
            "PRODUCT_TAG_ID": "IIR",
            "Full Name": data.fullName,
            "Email (standard)": data.email, 
            "Phone_Number": data.phone,
            "Drop_Reason": "Timeout (5 Min)" 
          });
          console.log("MoEngage: OTP Dropped Tracked");
        });
      }
    } catch (error) {
      console.log("Error in MoEngage trackOtpDropped:", error);
    }
  },

  downLoadStarterKitClicked: async (data) => {
    try {
      
      window.Moengage.identifyUser(data.phone).then(() => {
        debugger
        window.Moengage.add_user_name(data.fullName); 
        window.Moengage.add_email(data.email);
        window.Moengage.track_event("Download Starter Kit Clicked", {
          "utm_source": "LP_PAID_IIR",
          "PRODUCT_TAG_ID": "IIR",
          "Full Name": data.fullName,
          "Email (standard)": data.email, 
          "Phone_Number": data.phone
        });
        setTimeout(() => {
          window.Moengage.destroy_session();
        }, 2000);
     })
    } catch (error) {
      console.log("Error in MoEngage downLoadStarterKitClicked:", error);
    }
  }
};